import React from 'react';
import { Link } from 'react-router-dom';
import { LuMoveRight } from 'react-icons/lu';
import Button from '../../components/Button';
import { getNewsPreviewText, getSortedNewsData } from '../../data/newsData';

const BriefNews = ({ setChosenNews }) => {
  const sortedNews = getSortedNewsData().sort(
    (firstItem, secondItem) => secondItem.id - firstItem.id,
  );

  return (
    <div
      id="brief_news"
      className="w-full h-fit px-6 md:px-12 lg:px-32 py-16 bg-darkGrey"
    >
      <div className="flex flex-col lg:flex-row items-center gap-2 justify-start">
        <div className="bg-secondary w-[30px] lg:w-[80px] h-[4px]"></div>
        <h1 className="text-secondary font-semibold font-rubik">NEWS</h1>
      </div>
      <h1 className="mt-4 text-primary font-bold text-xl lg:text-4xl text-center lg:text-start">
        Latest News and Updates
      </h1>

      <div className="flex flex-col">
        <div className="flex flex-col items-center lg:items-start lg:flex-row gap-12 mt-12">
          {sortedNews?.slice(0, 4).map((news) => {
            const previewText = getNewsPreviewText(news);
            return (
              <div
                key={news.id}
                className="flex flex-col px-2 lg:px-4 py-3 lg:py-6 max-w-[500px] lg:w-[350px]"
              >
                <div className="overflow-hidden rounded-xl w-full h-[200px]">
                  <img
                    src={news.image}
                    alt=""
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex items-center gap-4 my-2 ">
                  <p className="font-rubik font-bold text-secondary text-sm">
                    {news.category}
                  </p>
                  <p className="text-fontGrey text-sm lg:text-base">
                    {news.date}
                  </p>
                </div>
                <h1 className="font-bold text-lg lg:text-lg">
                  {news.title.length > 40
                    ? news.title.slice(0, 40) + '...'
                    : news.title}
                </h1>
                <p className="my-3 text-sm lg:text-base">
                  {' '}
                  {previewText.length > 100
                    ? previewText.slice(0, 100) + '...'
                    : previewText}
                </p>

                <Link to={'/news/single'} className="w-fit">
                  <div
                    className="flex gap-2 items-center w-fit cursor-pointer"
                    onClick={() => {
                      setChosenNews(news.id);
                    }}
                  >
                    <p className="text-secondary font-rubik">Read more</p>
                    <LuMoveRight size={20} color="#FDB935" />
                  </div>
                </Link>
              </div>
            );
          })}
        </div>

        <div className="flex w-full justify-center lg:justify-end mt-6">
          <Link to="/news" className="w-fit">
            <Button
              type="button"
              content={
                <div className="flex items-center justify-center px-4 py-1">
                  <p className="text-white font-rubik font-normal">View More</p>
                </div>
              }
              loading={false}
              btnColor="secondary"
              Style={'text-white w-max ml-0 flex self-end'}
            />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default BriefNews;
